export const SECTIONS = [
  { id: 'general', title: '1. Общие положения' },
  { id: 'operator', title: '2. Оператор персональных данных' },
  { id: 'composition', title: '3. Состав обрабатываемых данных' },
  { id: 'purposes', title: '4. Цели обработки' },
  { id: 'legal', title: '5. Правовые основания' },
  { id: 'methods', title: '6. Порядок и способы обработки' },
  { id: 'cookies', title: '7. Файлы Cookie и аналитика' },
  { id: 'transfer', title: '8. Передача третьим лицам' },
  { id: 'storage', title: '9. Сроки хранения' },
  { id: 'rights', title: '10. Права субъекта данных' },
  { id: 'security', title: '11. Меры защиты' },
  { id: 'children', title: '12. Данные несовершеннолетних' },
  { id: 'changes', title: '13. Изменения политики' },
  { id: 'contacts', title: '14. Контакты' },
];

export const DATA_CATEGORIES = [
  { badge: 'Идентификация', text: 'ФИО, дата рождения, пол, гражданство.' },
  { badge: 'Контакты', text: 'Email, телефон, почтовый адрес, мессенджеры.' },
  { badge: 'Аккаунт', text: 'Логин, пароль (в хешированном виде), настройки профиля.' },
  { badge: 'Технические', text: 'IP-адрес, cookie, данные браузера и устройства, referer.' },
  { badge: 'Активность', text: 'История действий в сервисе, дата и время обращений.' },
  { badge: 'Платёжные', text: 'Реквизиты для оплаты (обрабатываются платёжным провайдером).' },
];
